<div class="custom-dialog-container">
  <div layout="row"
    layout-align="space-between center"
    class="claims-edit-header"
    flex>
    @if (editMode) {
      <div
        class="modal-dialog-title"
        flex
        [translate]="'claims.editClaim'"
      [translateParams]="{ claimId: data.claim.id }">Edit claim</div>
    }
    @if (!editMode) {
      <div
        class="modal-dialog-title"
        flex
      [translate]="'claims.newClaim'">Add claim</div>
    }
    <button tabindex="-1"
      mat-icon-button
      (click)="onCloseClicked()">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <div class="flex-padding-24-margin-fix">
    <form [formGroup]="claimForm"
      (ngSubmit)="addNewClaim($event)">
      <div layout="column">
        <div layout="row"
          layout-wrap>
          @if (!editMode) {
            <mat-form-field flex="100"
              class="flex-padding-24">
              <mat-label>{{ 'claims.option' | translate }}</mat-label>
              <mat-select required
                formControlName="claimOption">
                @for (claimOption of claimOptions; track claimOption.id) {
                  <mat-option [value]="claimOption">{{ claimOption.name }}</mat-option>
                }
              </mat-select>
              @if (claimForm.get('claimOption').hasError('required')) {
                <mat-error
                  [translate]="'forms.required'">
                  Field is required error
                </mat-error>
              }
            </mat-form-field>
          }
          @if (editMode) {
            <mat-form-field flex="100"
              class="flex-padding-24">
              <mat-label>{{ 'claims.option' | translate }}</mat-label>
              <input type="text"
                matInput
                readonly
                [matTooltip]="data.claim.claimOption?.code"
                [value]="data.claim.claimOption?.name">
            </mat-form-field>
            <mat-form-field flex="50"
              class="flex-padding-24">
              <mat-label>{{ 'claims.completedAt' | translate }}</mat-label>
              <input type="text"
                matInput
                readonly
                [value]="(data.claim.completedAt | itfgDateFormat) || '-'">
            </mat-form-field>
            <mat-form-field flex="50"
              class="flex-padding-24">
              <mat-label>{{ 'claims.completedBy' | translate }}</mat-label>
              <input type="text"
                matInput
                readonly
                [matTooltip]="data.claim.completedBy?.email"
                [value]="(data.claim.completedBy | administratorFullName) || '-'">
            </mat-form-field>
            <mat-form-field flex="50"
              class="flex-padding-24">
              <mat-label>{{ 'claims.acceptedAt' | translate }}</mat-label>
              <input type="text"
                matInput
                readonly
                [value]="(data.claim.acceptedAt | itfgDateFormat) || '-'">
            </mat-form-field>
            <mat-form-field flex="50"
              class="flex-padding-24">
              <mat-label>{{ 'claims.acceptedBy' | translate }}</mat-label>
              <input type="text"
                matInput
                readonly
                [matTooltip]="data.claim.acceptedBy?.email"
                [value]="(data.claim.acceptedBy | administratorFullName) || '-'">
            </mat-form-field>
          }
            @if (editMode) {
              <mat-form-field
                class="flex-padding-24"
                flex="100">
                <mat-label>{{ 'claims.notes' | translate }}</mat-label>
                <textarea matInput
                  cdkTextareaAutosize
                  cdkAutosizeMaxRows="8"
                  cdkAutosizeMinRows="3"
                  formControlName="notes"
                  itfgAutoScrollTextarea></textarea>
              </mat-form-field>
            }
            @if (editMode) {
              <div
                layout="row"
                flex="100"
                layout-align="start start">
                <mat-checkbox formControlName="completed">
                  <div class="checkbox-label-text"
                  [translate]="'claims.completed'">Completed claim</div>
                </mat-checkbox>
                @if (forgetClaim) {
                  <mat-checkbox formControlName="accepted">
                    <div class="checkbox-label-text"
                    [translate]="'claims.accepted'">Accepted claim</div>
                  </mat-checkbox>
                }
              </div>
            }
          </div>
        </div>
        <div layout="row"
          layout-wrap
          layout-align="end end">
          <div class="flex-padding-24">
            <button type="submit"
              color="primary"
              mat-raised-button
              [disabled]="['CLAIM_WRITE'] | isUnauthorized | async">
              {{ 'global.save' | translate }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
